import { Component } from 'react';
import ReactModal from '../../../components/Modal';
import DataTable from '../../../components/Datatable';
import { getSortKeys, setAdditionalStyles } from '../../../helpers/table';
import { COLUMNS } from './keys';

class ExpandUrls extends Component {
    constructor(props) {
        super(props);

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);

        this.state = {
            isOpen: false,
        };
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => {
            return item.unique_url_slug.toLowerCase().includes(search.toLowerCase());
        });
    }

    onOpen() {
        this.setState({
            isOpen: true,
        });
    }

    onClose() {
        this.setState({
            isOpen: false,
        });
    }

    render() {
        const uniqueUrls =
            this.props.items.filter(
                (item, i, arr) =>
                    arr.findIndex((t) => t.unique_url_slug === item.unique_url_slug) === i,
            ) ?? [];

        return (
            <div>
                <button className="table-action-main-btn" onClick={this.onOpen}>
                    Expand
                </button>
                {this.state.isOpen && (
                    <ReactModal modalState={this.state.isOpen} className="width-md">
                        <div>
                            <DataTable
                                nodes={uniqueUrls}
                                sortFns={getSortKeys(COLUMNS())}
                                COLUMNS={COLUMNS(this.onOpen)}
                                fileName="Expanded URLs"
                                header="Expanded URLs"
                                searchFunction={this.searchFunction}
                                uniqKey={'unique_url_slug'}
                                notUseDefaultStyle
                                additionalStyles={setAdditionalStyles(COLUMNS())}
                            />
                        </div>
                        <div className="btn-wrapper">
                            <button
                                type="button"
                                className="button button-outline button-primary width-sm btn"
                                onClick={this.onClose}
                                style={{ lineHeight: 'unset' }}
                            >
                                {'Close'}
                            </button>
                        </div>
                    </ReactModal>
                )}
            </div>
        );
    }
}

export default ExpandUrls;
